var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgToDo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.30344 4.05005C3.65844 4.05005 3.14844 4.57505 3.14844 5.20505V18.8101C3.14844 19.4551 3.67344 19.9651 4.30344 19.9651H14.9234C15.5684 19.9651 16.0784 19.4401 16.0784 18.8101V8.31005L11.8184 4.05005H4.30344ZM15.0884 18.8251C15.0884 18.9151 15.0134 18.9901 14.9234 18.9901H4.30344C4.21344 18.9901 4.13844 18.9151 4.13844 18.8251V5.20505C4.13844 5.11505 4.21344 5.04005 4.30344 5.04005H10.9784V7.98005C10.9784 8.62505 11.5034 9.13505 12.1334 9.13505H15.0884V18.8251ZM11.9684 5.62505L14.5034 8.16005H12.1334C12.0434 8.16005 11.9684 8.08505 11.9684 7.99505V5.62505Z",
    fill: "#606368"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 10.5002H12.5",
    stroke: "#606368",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 13.5002H12.5",
    stroke: "#606368",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 16.5002H12.5",
    stroke: "#606368",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToDo);
export default __webpack_public_path__ + "static/media/To-do.2276fd12.svg";
export { ForwardRef as ReactComponent };